function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect } from "react";
import { useBoundingRect } from "./hooks/useBoundingRect";
import { SButton } from "./components";
// Define a default context value with an explicit type
const defaultContextValue = {
    isOpen: false,
    setIsOpen: ()=>{},
    buttonRect: undefined
};
const MenuContext = /*#__PURE__*/ createContext(defaultContextValue);
const SContextMenu = ({ isOpen, setIsOpen, children })=>{
    const { ref, rect, recalculate } = useBoundingRect();
    // Wrap setIsOpen to recalculate first
    const handleSetIsOpen = (newIsOpen)=>{
        if (newIsOpen) {
            recalculate();
            requestAnimationFrame(()=>{
                setIsOpen(true);
            });
        } else {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            isOpen,
            setIsOpen: handleSetIsOpen,
            buttonRect: rect
        },
        children: /*#__PURE__*/ _jsx("div", {
            ref: ref,
            children: children
        })
    });
};
SContextMenu.Open = (_param)=>{
    var { render, children, menu } = _param, buttonProps = _object_without_properties(_param, [
        "render",
        "children",
        "menu"
    ]);
    const { isOpen, setIsOpen } = useContext(MenuContext);
    return render === undefined ? /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(SButton, _object_spread_props(_object_spread({}, buttonProps), {
                onClick: ()=>{
                    setIsOpen(!isOpen);
                },
                children: children
            })),
            menu
        ]
    }) : /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            render({
                isOpen,
                setIsOpen
            }),
            menu
        ]
    });
};
SContextMenu.Menu = ({ width, position = "absolute", children, direction = "right" })=>{
    const { isOpen, setIsOpen, buttonRect } = useContext(MenuContext);
    const { ref, rect, recalculate } = useBoundingRect();
    useEffect(()=>{
        recalculate();
    }, [
        isOpen
    ]);
    const menuWidth = width || 375;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                onClick: (e)=>setIsOpen(false),
                className: `fixed ${isOpen ? "" : "pointer-events-none"}  z-[999] top-0 right-0 left-0 bottom-0`
            }),
            isOpen && position == "absolute" && /*#__PURE__*/ _jsx("div", {
                className: `absolute top-[100%] ${direction === "right" ? "right-0" : "left-0"} z-[999]`,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "relative top-[8px] right-0 z-[999]",
                    style: {
                        width: menuWidth
                    },
                    ref: ref,
                    children: children
                })
            }),
            isOpen && position == "fixed" && /*#__PURE__*/ _jsx("div", {
                className: "fixed top-[8px] right-0 z-[1000]",
                style: {
                    width: menuWidth,
                    top: ((buttonRect === null || buttonRect === void 0 ? void 0 : buttonRect.top) || 0) + ((buttonRect === null || buttonRect === void 0 ? void 0 : buttonRect.height) || 0) + 10,
                    left: buttonRect === null || buttonRect === void 0 ? void 0 : buttonRect.left
                },
                ref: ref,
                children: children
            })
        ]
    });
};
export default SContextMenu;
